<script lang="ts" setup>
import { i18n } from '@/i18n';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { useUnmanagedBusinessStore } from '@/unmanagedBusinessModule/pages/unmanagedBusinessStore';
import { storeToRefs } from 'pinia';
import { TableContentItem } from '../../interface/tableContentItems';

const t = i18n.t;

const store = useUnmanagedBusinessStore();
const { state } = storeToRefs(store);
const { setSelectedBusiness, openModal } = store;

const props = defineProps<{
  item: TableContentItem;
}>();

/**
 * ボタンクリック時の処理
 */
const onClick = () => {
  setSelectedBusiness(props.item);
  openModal('registerBusiness');
};
</script>
<template>
  <TextButton @click="onClick">
    {{ t('取引登録') }}
  </TextButton>
</template>
<style lang="scss" scoped></style>
